module.exports = __webpack_public_path__ + "img/u.f3d78468.png";